import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const B2ctopup = ()=>{
    const [b2ctopup, setB2ctopup] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`b2cTopUp?page=${page}`);
            setB2ctopup(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`b2cTopUp/${id}`);
            setB2ctopup(b2ctopup.filter((b2ctopup) => b2ctopup.id !== id));
        }
    }
    return (
        <Wrapper pageTitle={'B2ctopup'}>
            <InnerNav createLink={'/b2ctopupCreate'} listLink={'/b2ctopup'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Source C2B </th>
                                    <th className="px-4 py-3">Receiver B2C </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th>Trx Cost</th>
                                    <th>Reference</th>
                                    <th>Transaction ID</th>
                                    <th>Desc</th>
                                    <th>Receiver</th>
                                    <th>Working Balance</th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {b2ctopup.map((b2ctopup)=>{
                                         return(
                                             <tr key={b2ctopup.id} className="text-gray-700 dark:text-gray-400">
                                                 <td className="px-4 py-5">{b2ctopup.id}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.source_c2b}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.receiver_b2c}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.transaction_cost}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.reference}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.transaction_id}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.result_desc}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.receiver_name}</td>
                                                 <td className="px-4 py-3 text-sm">{b2ctopup.working_c2b_bal}</td>
                                                 <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/b2ctopup/${b2ctopup.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(b2ctopup.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default B2ctopup;